import React, {ReactElement} from 'react';
import {NxDefaultNumberFormat} from '../DefaultNumberFormat';

export interface NxCashMaskProps {
  value: number;
  decimals?: number;
}

const NxCashMask = (props: NxCashMaskProps): ReactElement => (
  <NxDefaultNumberFormat
    {...props}
    displayType={'text'}
    decimalScale={props.decimals}
  />
);

export default NxCashMask;
